<template>
  <div class="brand-section" v-if="cart_items_count">
    <div class="brand-img payment">
      <div>
        <img
          :src="logoUrl"
          @error="logoUrl = cart_brand.data.company_logo"
          class="img-fluid"
          :alt="_T_DB(cart_brand.data, 'name')"
        />
        <!-- <img :src="brand.company_logo" class="img-fluid" alt="" /> -->
      </div>
    </div>
    <div class="brand-detail">
      <!-- <h6>{{ _T('fast food') }}</h6> -->
      <h3>{{ _T_DB(cart_brand.data, 'name') || '' }}</h3>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PaymentBrandLogo',
  data() {
    return {
      logoUrl: '',
    }
  },
  methods: {},
  beforeMount() {},
  beforeDestroy() {},
  watch: {
    cart_brand(brand) {
      if (brand && brand.logo) {
        this.logoUrl = brand.logo.replace(
          'company_logos',
          'company_logos/large'
        )
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentBrand',
      '_T',
      '_T_DB',
      'find_brand_by_main_id',
      'cart_items_count',
      'cart_brand',
      'siteDomain',
    ]),
  },
}
</script>
<style lang="scss" scoped>
.body-rtl {
  .brand-section {
    padding: 0;
    .brand-detail {
      text-align: right;
      padding-right: 30px;
    }
  }
}
</style>
